import {Injectable, OnInit} from '@angular/core';
import {userDetails} from '../model/customer-data.model';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AuthguardServiceService implements OnInit {
  /** Customer profile from APIGEE */
  private apigeeCustomerData: userDetails;

  user: any;

  public isAuthenticatedFlagSubject = new BehaviorSubject(false);
  public authFlagObservable$ = this.isAuthenticatedFlagSubject.asObservable();

  constructor(public http: HttpClient) {
  }

  /** Returning empty data for APIGEE to avoid crash */
  public getAPIGEEEmptyCustomerProfile() {
    const firstName = '';

    const apiGeeCustomerProfile: userDetails = {
      dealerOrgId: '',
      dealerOrgName: '',
      emailAddress: '',
      fannieMaeUser: false,
      firstName,
      lastName: '',
      institutionId: '',
      mobileNumber: '',
      parentName: '',
      groups: [],
      sellerServicerNo: '',
      uid: '',
      userType: 0,
      workNumber: '',
      isInternalUser: '',
      isExternalUser: '',
      subscriberName: '',
      corporateFamilyCode: '',
      roleMatch: false,
      roles:[]
    };

    return apiGeeCustomerProfile;
  }

  /** APIGEE Customer information */
  public getAPIGEECustomerData() {
    if (this.apigeeCustomerData) {

      return this.apigeeCustomerData;
    }
    return this.getAPIGEEEmptyCustomerProfile();
  }

  ngOnInit() {

    localStorage.setItem('SessionUser', this.user);
  }

  public get(url: string, options?: any): Observable<any> {
    return this.http.get(url, options); // talking to backend
  }

  /** customer information subscription APIGEE */
  public customerApigeeInfoSub = new Subject<userDetails>();

  /** Save all information received in APIGEE profile */
  public saveApigeeCustomerData(customerInfo) {

    this.apigeeCustomerData = customerInfo;
    /** Check whether logged in use us external **/
    const isInternal = this.apigeeCustomerData.isInternalUser;

    if (!isInternal)
    {
      sessionStorage.setItem('isExternal', 'true');
    }

    if (this.apigeeCustomerData) {
      this.customerApigeeInfoSub.next(this.apigeeCustomerData);
    }
  }

  /* This method enables the authentication flag once userId added to session */
  public  setAuthFlag() {
    this.isAuthenticatedFlagSubject.next(true);

  }

}
